(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/react/start-page.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/react/start-page.js');

'use strict';

const {
  StartHeader,
  StartText,
  StartPackages,
  StartButtons,
  ButtonChooseNumbers,
  ButtonHowTo
} = svs.lotto.react.components;
const {
  Debug
} = svs.tur.grid;
const StartPage = () => React.createElement("div", {
  className: "lotto-start-body f-content"
}, React.createElement(Debug, null), React.createElement(StartHeader, null), React.createElement(StartText, null), React.createElement(ButtonChooseNumbers, null), React.createElement(StartPackages, null), React.createElement(StartButtons, null), React.createElement(ButtonHowTo, null));
const rootEl = document.getElementById('ngStartPageRegion');
if (rootEl) {
  ReactDOM.render(React.createElement(StartPage, null), rootEl);
}

 })(window);